import React, { useState } from "react";
import img from "./login.webp"

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 🔑 Static credentials
    const staticUser = {
      email: "admin@deveshmeditechindia.com",
      password: "@deveshmeditechindia0614",
    };

    if (
      formData.email === staticUser.email &&
      formData.password === staticUser.password
    ) {
      localStorage.setItem("token", "dummy-static-token");
      alert("✅ Login successful");
      window.location.href = "/products";
    } else {
      alert("❌ Invalid username or password");
    }
  };

  return (
    <div className="container-fluid vh-100">
      <div className="row h-100">
        {/* Left Side Image */}
        <div className="col-md-6 d-none d-md-flex align-items-center justify-content-center bg-light">
          <img
            src={img} // replace with your own image
            alt="Login visual"
            className="img-fluid"
            style={{ maxHeight: "90%", borderRadius: "10px" }}
          />
        </div>

        {/* Right Side Form */}
        <div className="col-md-6 d-flex align-items-center justify-content-center">
          <div className="w-75">
            <h2 className="mb-3 text-center">Welcome Back</h2>
            <p className="text-muted text-center mb-4">
              Please login to continue
            </p>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  placeholder="Enter your password"
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary w-100">
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
